import styles from './Projects.module.css'
import flowdeskImg from './ProjectsImg/flowdesk.png';
import novaBuildImg from './ProjectsImg/novaBuild.png';
import { useTranslation } from 'react-i18next';


export const Projects = () => {
  const { t } = useTranslation();

  const projects = [
    {
      id: 1,
      title: 'Flowdesk',
      description: t('projects.flowdesk'),
      technologies: ['React', 'React Router', 'JavaScript', 'Context API', 'CSS modules'],
      link: 'https://flowdesk-steel.vercel.app/',
      img: flowdeskImg,
    },
    {
      id: 2,
      title: 'NovaBuild',
      description: t('projects.novabuild'),
      technologies: ['React', 'JavaScript', 'CSS modules'],
      link: 'https://nova-build-teal.vercel.app/',
      img: novaBuildImg,
    }
  ]
  
  return (
    <div className={styles.projects}>
      <h1 className={styles.title}>
        {/* Moje Projekty */}
        {t('projects.title')}
      </h1>
      <div className={styles.grid}>
        {projects.map((project) => (
          <div key={project.id} className={styles.card}>
            <div className={styles['card-image']}>
              <img src={project.img} alt={project.title} />
            </div>
            <div className={styles['card-content']}>
              <h2 className={styles['card-title']}>{project.title}</h2>
              <p className={styles['card-description']}>{project.description}</p>
              <div className={styles['card-tags']}>
                {project.technologies.map((tech) => (
                  <span key={tech} className={styles.tag}>
                    {tech}
                  </span>
                ))}
              </div>
              <a href={project.link} target="_blank" rel="noreferrer"className={styles['card-link']}>
                {/* Více informací → */}
                {t('projects.moreInfo')}→
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}